module.exports = require('./components/Modal');




/*****************
 ** WEBPACK FOOTER
 ** ./~/react-modal/lib/index.js
 ** module id = ./node_modules/react-modal/lib/index.js
 ** module chunks = 1
 **/